export default __webpack_public_path__ + "static/media/arrowBack2.eff01061.svg";